import { render } from "./Pivot.vue?vue&type=template&id=30281f1b&ts=true"
import script from "./Pivot.vue?vue&type=script&lang=ts"
export * from "./Pivot.vue?vue&type=script&lang=ts"

import "./Pivot.vue?vue&type=style&index=0&id=30281f1b&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__